import { SubscriptionInvoice } from '../types/subscriptionInvoice'
import { getRequest } from '../utils'

interface FetchUmbrellaInvoicesResponse {
  data: SubscriptionInvoice[]
}

export const fetchUmbrellaInvoices = (umbrellaId: string): Promise<FetchUmbrellaInvoicesResponse> => {
  return getRequest(`/umbrellas/${umbrellaId}/invoices`)
}

export const fetchSubscriptionInvoices = (organizationId: string): Promise<SubscriptionInvoice[]> => {
  return getRequest(`/integrations/billing/${organizationId}/invoices`)
}
